module.exports = __webpack_public_path__ + "img/num-01.a0200f19.png";